import { RootState } from '@reducers/index';
import { ChallengeGroup } from 'src/types/shared/ChallengeGroup';

export const getChallengeGroupsIsFetching = (state: RootState): boolean =>
    state.challengeGroupsReducer.isFetching;
export const getChallengeGroupsFetchError = (state: RootState): string | null =>
    state.challengeGroupsReducer.fetchError;
export const getChallengeGroupsIsPosting = (state: RootState): boolean =>
    state.challengeGroupsReducer.isPosting;
export const getChallengeGroupsPostSuccess = (state: RootState): boolean =>
    state.challengeGroupsReducer.postSuccess;
export const getChallengeGroupsPostError = (state: RootState): string | null =>
    state.challengeGroupsReducer.postError;
export const getChallengeGroupsIsDeleting = (state: RootState): boolean =>
    state.challengeGroupsReducer.isDeleting;
export const getChallengeGroupsDeleteSuccess = (state: RootState): boolean =>
    state.challengeGroupsReducer.deleteSuccess;
export const getChallengeGroupsDeleteError = (state: RootState): string | null =>
    state.challengeGroupsReducer.deleteError;
export const getChallengeGroupsIsPatching = (state: RootState): boolean =>
    state.challengeGroupsReducer.isPatching;
export const getChallengeGroupsPatchSuccess = (state: RootState): boolean =>
    state.challengeGroupsReducer.patchSuccess;
export const getChallengeGroupsPatchError = (state: RootState): string | null =>
    state.challengeGroupsReducer.patchError;
export const getChallengeGroups = (state: RootState): Record<number, ChallengeGroup> =>
    state.challengeGroupsReducer.challengeGroups;
export const getChallengeGroup = (state: RootState, id: number): ChallengeGroup =>
    state.challengeGroupsReducer.challengeGroups[id] ?? {};
export const getChallengeHolders = (state: RootState) =>
    state.challengeGroupsReducer.challengeHolders;
export const getChallengeGroupAdmins = (state: RootState) =>
    state.challengeGroupsReducer.challengeGroupAdmins || [];
export const getChallengeGroupViewers = (state: RootState) =>
    state.challengeGroupsReducer.challengeGroupViewers || [];
